<template>
    <div>
        <Title title="专家" :logo="true" :tablist="tab_list" :tabactive="tab_active" @titleTabActive="titleTabActive"/>

        <div class="page-loading" v-if="list.length === 0">
            <van-skeleton title :row="8" />
        </div>
        <template v-else>
            <div class="expert_filter">
                <div class="tit">筛选</div>
                <span :class="sort === 'zong'?'curr':''" @click="changeFt(1)">综合</span>
                <span :class="sort === 'rate'?'curr':''" @click="changeFt(2)">胜率</span>
                <span :class="sort === 'activity'?'curr':''" @click="changeFt(3)">活跃度</span>
                <span :class="sort === 'price'?'curr':''" @click="changeFt(4)">价格</span>
            </div>
            <div class="expert_list">
                <ul ref="exul">
                    <li v-for="(c,i) in list" :key="i" ref="exli">
                        <router-link class="con" :to="'/expert/'+c.ename" v-if="c.name">
                            <div class="img"><img :src="c.portrait"/><i title="新预测" v-if="c.commend_num">{{ c.commend_num }}</i></div>
                            <div class="name">{{ c.name }}</div>
                            <div class="yname" v-if="c.yname">{{ c.yname }}</div>
                            <div class="slprc">
                            <div class="slag" v-if="c.sl.length>0"><span>{{ c.sl[0].name }}</span><b>{{ c.sl[0].sl }}%</b></div>
                            <div class="slag price"><span>FXB</span><b>{{ c.price }}</b></div>
                            </div>
                            <div class="more">查看详情</div>
                        </router-link>
                        <a v-else class="bu"></a>
                    </li>
                </ul>
            </div>

        </template>
    </div>
</template>

<script>
    import Title from './public/title'
    export default {
        name: "ball",
        components: {
            Title
        },
        data() {
            return {
                list: [],
                tab_list: ['足球', '篮球'],
                tab_active: 0,
                ball: 1,
                page: 1,
                total: 0,
                size: 0,
                sort_list: ['', 'zong', 'rate', 'activity', 'price'],
                sort: 'zong'
            }
        },
        watch: {
          // '$route': {
          //     handler () {
          //         document.documentElement.scrollTop = this.$route.meta.y
          // //         // console.log(router.name)
          // //         // this.list = []
          // //         this.tab_active= 0
          // //         this.ball= 1
          // //         this.page= 1
          // //         this.total= 0
          // //         this.size= 0
          // //         this.sort='zong'
          // //         this.getdata()
          //     }
          // },
        },
        created() {
            let that = this
            that.getdata()
        },
        methods: {
            titleTabActive(i){
                this.tab_active = i
                this.ball = i+1
                this.page = 1
                // this.list = []
                this.getdata()
            },
            changeFt(t){
                this.sort = this.sort_list[t]
                this.getdata()
            },
            getdata(){
                let that = this
                that.$get(that.$api.expert_list,{page: that.page, ball: that.ball, sort: that.sort})
                    .then(function (res) {
                        // console.log(res)
                        if(res.code === 1) {
                            that.list = res.data.list
                            that.total = res.data.total
                            that.size = res.data.size
                            //填补空白位
                            if(res.data.list.length > 0) {
                                setTimeout(function () {
                                    let ulw = that.$refs.exul.offsetWidth, liw = that.$refs.exli[0].offsetWidth
                                    let rowSize = Math.round(ulw / liw)
                                    let rowPlus = that.list.length % rowSize
                                    if (rowPlus > 0) {
                                        for (let i = 0; i < rowPlus; i++) {
                                            that.list.push({})
                                        }
                                    }
                                }, 1)
                            }
                        }
                        that.$backTop()
                    })
            },
        },
        // beforeRouteEnter(to, from, next){
        //     next(vm =>{
        //         // console.log(from) // 上一页面的路由信息
        //         // console.log(to.meta.y, vm.$route.meta.y)
        //         document.documentElement.scrollTop = vm.$route.meta.y
        //     })
        // }
    }
</script>

<style scoped>
</style>
